import { createFeatureSelector, createSelector } from "@ngrx/store";
import { connectedProductFeatureKey } from "./connected-product.reducer";

export const selectConnectedProductState = createFeatureSelector(connectedProductFeatureKey);

export const selectConnectedProduct = createSelector(
  selectConnectedProductState,
  (state: any) => state
);
